"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUserRequest = exports.EndFixedPriceItemRequest = exports.AddFixedPriceItemRequest = exports.BulkDataExchangeRequestsClosing = exports.BulkDataExchangeRequestsOpening = exports.baseXmlHeader = exports.isSingle = exports.STOCK_TYPES = exports.getEarliestTime = exports.getNextMonthDate = exports.getDateYYYYMMDD = exports.getYesterday = exports.orderContainsSealed = exports.hasUnresolvedIssues = exports.hasIssues = exports.getIssues = exports.getAllArticleIssues = exports.getOrderIssues = exports.getOrderTrackingNumber = exports.isValidDate = exports.getPaidOrdersId = exports.getOrderState = exports.hydrateOrder = exports.getCardmarketOrderPhoneNumber = exports.escapeDoubleQuotes = exports.hydrateOrderArticles = exports.getArticleProperties = exports.getOrderFromMkmOrder = exports.getOrderArticleFromMkmOrderArticle = exports.getGameFromId = exports.stripBrandingComment = exports.getBrandedComment = exports.BRANDING_COMMENT_V3 = exports.BRANDING_COMMENT_V2 = exports.BRANDING_COMMENT_V1 = exports.roundTo2Decimals = exports.sleep = void 0;
var constants_1 = require("./constants");
var sleep = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
exports.sleep = sleep;
var roundTo2Decimals = function (number) {
    return Math.round(number * 100) / 100;
};
exports.roundTo2Decimals = roundTo2Decimals;
exports.BRANDING_COMMENT_V1 = 'listed with tcgpt.app';
exports.BRANDING_COMMENT_V2 = 'listed with TCGPowerTools(.com)';
exports.BRANDING_COMMENT_V3 = '';
var getBrandedComment = function (comment) {
    return comment;
};
exports.getBrandedComment = getBrandedComment;
var stripBrandingComment = function (comment) {
    if (comment.includes(exports.BRANDING_COMMENT_V1)) {
        comment = comment
            .replace(" | ".concat(exports.BRANDING_COMMENT_V1), '')
            .replace("".concat(exports.BRANDING_COMMENT_V1, " | "), '');
    }
    if (comment.includes(exports.BRANDING_COMMENT_V2)) {
        comment = comment
            .replace(" | ".concat(exports.BRANDING_COMMENT_V2), '')
            .replace("".concat(exports.BRANDING_COMMENT_V2, " | "), '');
    }
    return comment;
};
exports.stripBrandingComment = stripBrandingComment;
var getGameFromId = function (idGame) {
    var inverseGameMap = {
        1: 'Magic',
        3: 'Yugioh',
        6: 'Pokemon',
        8: 'Vanguard',
        9: 'FF',
        13: 'DBS',
        10: 'WS',
        16: 'FAB',
        17: 'Digimon',
        18: 'OnePiece',
        19: 'Lorcana',
        20: 'BSS',
        21: 'SWU',
        22: 'Riftbound',
        23: 'Cyberpunk',
        24: 'Gundam',
        25: 'Sorcery',
    };
    return inverseGameMap[idGame];
};
exports.getGameFromId = getGameFromId;
var getLastDate = function (state) {
    if (state.dateReceived) {
        return state.dateReceived;
    }
    if (state.dateSent) {
        return state.dateSent;
    }
    if (state.datePaid) {
        return state.datePaid;
    }
    return state.dateBought;
};
var getOrderArticleFromMkmOrderArticle = function (order, mkmOa, ptArticles) {
    var ptArticle;
    if (ptArticles && ptArticles.length > 0) {
        ptArticle = ptArticles.find(function (pta) { return pta.idArticle === mkmOa.idArticle; });
    }
    var enrichedOa = __assign({}, mkmOa);
    // enrichedOa.product.expansionCode = ptArticle?.product?.expansionCode
    var orderArticle = __assign({ idOrder: order.idOrder, articleState: ptArticle ? ptArticle.articleState : '', issues: ptArticle ? ptArticle.issues : [], idCurrency: order.idCurrency, currencyCode: order.currencyCode, pickedQuantity: ptArticle ? ptArticle.pickedQuantity : 0 }, enrichedOa);
    return orderArticle;
};
exports.getOrderArticleFromMkmOrderArticle = getOrderArticleFromMkmOrderArticle;
var getOrderFromMkmOrder = function (o) {
    var _a;
    var order = __assign(__assign({}, o.data), { pt: __assign({}, o.ptorder[0]) });
    var ptArticles = (_a = o.ptorder[0]) === null || _a === void 0 ? void 0 : _a.article;
    var orderArticles = o.data.article.map(function (mkmOa) {
        return (0, exports.getOrderArticleFromMkmOrderArticle)(order, mkmOa, ptArticles);
    });
    order.article = orderArticles;
    order.pt.updatedAt = getLastDate(order.state);
    return order;
};
exports.getOrderFromMkmOrder = getOrderFromMkmOrder;
var getArticleProperties = function (orderArticle) {
    var properties = [orderArticle.condition, orderArticle.language.languageName];
    if (orderArticle.isFoil) {
        properties.push('Foil');
    }
    if (orderArticle.isAltered) {
        properties.push('Altered');
    }
    if (orderArticle.isPlayset) {
        properties.push('Playset');
    }
    if (orderArticle.isSigned) {
        properties.push('Signed');
    }
    return properties.join(' ');
};
exports.getArticleProperties = getArticleProperties;
var hydrateOrderArticles = function (order, expansionMap, categoryMap) {
    var i = 1;
    var articleCategories = new Set();
    var articleGames = new Set();
    var orderArticles = order.article.map(function (oa) {
        var _a, _b, _c, _d;
        oa.idOrder = order.idOrder;
        oa.state = order.state;
        oa.pos = "".concat(i, "/").concat(order.article.length);
        oa.buyer = order.buyer;
        oa.properties = (0, exports.getArticleProperties)(oa);
        oa.product.gameName = (0, exports.getGameFromId)(oa.product.idGame);
        if (oa.product.gameName) {
            articleGames.add(oa.product.gameName);
        }
        oa.product.expansionCode = (_a = expansionMap[oa.product.expansion]) === null || _a === void 0 ? void 0 : _a.code;
        oa.product.expansionReleaseDate = (_b = expansionMap[oa.product.expansion]) === null || _b === void 0 ? void 0 : _b.releaseDate;
        oa.product.category = (_c = categoryMap[oa.idProduct]) === null || _c === void 0 ? void 0 : _c.category;
        oa.product.colors = (_d = categoryMap[oa.idProduct]) === null || _d === void 0 ? void 0 : _d.colors;
        if (oa.product.category) {
            articleCategories.add(oa.product.category);
        }
        i++;
        return oa;
    });
    return { orderArticles: orderArticles, articleCategories: articleCategories, articleGames: articleGames };
};
exports.hydrateOrderArticles = hydrateOrderArticles;
var escapeDoubleQuotes = function (value) {
    return (value || '').replace(/"/g, '""');
};
exports.escapeDoubleQuotes = escapeDoubleQuotes;
var getCardmarketOrderPhoneNumber = function (o) {
    var phoneNumber = o.phoneNumber || o.buyer.phone;
    if (phoneNumber) {
        return "\"".concat(phoneNumber, "\"");
    }
    else {
        return '';
    }
};
exports.getCardmarketOrderPhoneNumber = getCardmarketOrderPhoneNumber;
var hydrateOrder = function (order, expansionMap, categoryMap) {
    var _a = (0, exports.hydrateOrderArticles)(order, expansionMap, categoryMap), orderArticles = _a.orderArticles, articleCategories = _a.articleCategories, articleGames = _a.articleGames;
    order.article = orderArticles;
    order.pt.articleCategories = Array.from(articleCategories);
    order.pt.articleGames = Array.from(articleGames);
    return order;
};
exports.hydrateOrder = hydrateOrder;
var getOrderState = function (order) {
    var _a, _b, _c, _d;
    var mkmStateIndex = constants_1.ORDER_STATES.findIndex(function (s) { return s.name === order.state.state; });
    var ptStateIndex = -1;
    if ((_b = (_a = order.pt) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.state) {
        ptStateIndex = constants_1.ORDER_STATES.findIndex(function (s) { var _a, _b; return s.name === ((_b = (_a = order.pt) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.state); });
    }
    return mkmStateIndex > ptStateIndex ? order.state.state : (_d = (_c = order.pt) === null || _c === void 0 ? void 0 : _c.state) === null || _d === void 0 ? void 0 : _d.state;
};
exports.getOrderState = getOrderState;
var getPaidOrdersId = function (orders) {
    var MAX_NUM_PAID_ORDERS = 99;
    var paidOrders = orders.filter(function (o) { return (0, exports.getOrderState)(o) === 'paid'; });
    // sort paid orders by datePaid (ascending order)
    paidOrders.sort(function (a, b) {
        if (a.state.datePaid && b.state.datePaid) {
            return a.state.datePaid > b.state.datePaid ? 1 : -1;
        }
        else {
            return 0;
        }
    });
    // return only the first MAX_NUM_PAID_ORDERS
    paidOrders.splice(MAX_NUM_PAID_ORDERS);
    var paidOrdersId = paidOrders.map(function (o) { return o.idOrder; });
    return paidOrdersId;
};
exports.getPaidOrdersId = getPaidOrdersId;
var isValidDate = function (value) {
    var dateObject = new Date(value);
    return !isNaN(dateObject.getTime());
};
exports.isValidDate = isValidDate;
var getOrderTrackingNumber = function (order) {
    var trackingNumber = '';
    if (order.trackingNumber) {
        trackingNumber = order.trackingNumber;
    }
    else if (order.pt.trackingNumber) {
        trackingNumber = order.pt.trackingNumber;
    }
    return trackingNumber;
};
exports.getOrderTrackingNumber = getOrderTrackingNumber;
var getOrderIssues = function (order) {
    return (order.pt && order.pt.issues) || [];
};
exports.getOrderIssues = getOrderIssues;
var getAllArticleIssues = function (order) {
    var _a, _b;
    var issues = [];
    (_b = (_a = order.pt) === null || _a === void 0 ? void 0 : _a.article) === null || _b === void 0 ? void 0 : _b.map(function (a) {
        issues = issues.concat(a.issues);
    });
    return issues || [];
};
exports.getAllArticleIssues = getAllArticleIssues;
var getIssues = function (order) {
    return (0, exports.getOrderIssues)(order).concat((0, exports.getAllArticleIssues)(order));
};
exports.getIssues = getIssues;
var hasIssues = function (order) {
    var hasOrderIssues = (0, exports.getOrderIssues)(order).length > 0;
    var hasArticleIssues = (0, exports.getAllArticleIssues)(order).length > 0;
    return hasOrderIssues || hasArticleIssues;
};
exports.hasIssues = hasIssues;
var hasUnresolvedIssues = function (order) {
    var orderIssues = (0, exports.getOrderIssues)(order);
    var articleIssues = (0, exports.getAllArticleIssues)(order);
    var hasUnresolvedIssues = false;
    orderIssues.forEach(function (i) {
        if (!i.solved) {
            hasUnresolvedIssues = true;
            return;
        }
    });
    articleIssues.forEach(function (i) {
        if (!i.solved) {
            hasUnresolvedIssues = true;
            return;
        }
    });
    return hasUnresolvedIssues;
};
exports.hasUnresolvedIssues = hasUnresolvedIssues;
var orderContainsSealed = function (order) {
    var sealedCategories = order.pt.articleCategories.filter(function (c) { return !c.includes('Single') && c.match(/[a-zA-z]+/g); });
    return sealedCategories.length > 0;
};
exports.orderContainsSealed = orderContainsSealed;
var getYesterday = function () {
    var date = new Date();
    date.setDate(date.getDate() - 1);
    return date;
};
exports.getYesterday = getYesterday;
var getDateYYYYMMDD = function (date) {
    var isoDate = date.toISOString();
    return isoDate.split('T')[0];
};
exports.getDateYYYYMMDD = getDateYYYYMMDD;
var getNextMonthDate = function (date) {
    // Get the current year, month, and day
    var year = date.getFullYear();
    var month = date.getMonth();
    var day = date.getDate();
    // Create a new date object for the same year and the next month
    var nextMonthDate = new Date(date.setMonth(month + 1));
    // If the resulting month is greater than 11 (December), then it's a new year
    // and we need to set the year to the next year and the month to January (0)
    if (nextMonthDate.getMonth() > 11) {
        nextMonthDate.setFullYear(year + 1);
        nextMonthDate.setMonth(0);
    }
    // Get the last day of the month for the year and month we're interested in
    var lastDayOfMonth = new Date(year, month + 1, 0).getDate();
    // If the original day is greater than the last day of the month, set it to the last day of the month
    if (day > lastDayOfMonth) {
        nextMonthDate.setDate(lastDayOfMonth);
    }
    else {
        nextMonthDate.setDate(day);
    }
    return nextMonthDate;
};
exports.getNextMonthDate = getNextMonthDate;
var getEarliestTime = function (date1, date2) {
    var hours1 = date1.getUTCHours();
    var minutes1 = date1.getMinutes();
    var hours2 = date2.getUTCHours();
    var minutes2 = date2.getMinutes();
    if (hours1 > hours2 || (hours1 === hours2 && minutes1 > minutes2)) {
        return date2;
    }
    else {
        return date1;
    }
};
exports.getEarliestTime = getEarliestTime;
exports.STOCK_TYPES = {
    SINGLES: 'singles',
    SEALED: 'sealed',
};
var isSingle = function (item) {
    var _a;
    return (_a = item.categoryName) === null || _a === void 0 ? void 0 : _a.includes('Single');
};
exports.isSingle = isSingle;
exports.baseXmlHeader = '<?xml version="1.0" encoding="UTF-8"?>';
exports.BulkDataExchangeRequestsOpening = "<BulkDataExchangeRequests>\n<Header>\n   <SiteID>#SITE_ID#</SiteID>\n   <Version>#VERSION#</Version>\n</Header>";
exports.BulkDataExchangeRequestsClosing = "</BulkDataExchangeRequests>";
exports.AddFixedPriceItemRequest = "\n<AddFixedPriceItemRequest xmlns=\"urn:ebay:apis:eBLBaseComponents\">\n   <ErrorLanguage>en_US</ErrorLanguage>\n   <Version>#VERSION#</Version>\n   <Item>\n      <Description>\n         <![CDATA[TEST NICHT KAUFEN]]>\n      </Description>\n      <Title>#TITLE#</Title>\n      <SKU>#SKU#</SKU>\n      <PrimaryCategory>\n         <CategoryID>183454</CategoryID>\n      </PrimaryCategory>\n      <VATDetails>\n         <VATPercent>19</VATPercent>\n      </VATDetails>\n      <StartPrice>#PRICE#</StartPrice>\n      <ConditionID>3000</ConditionID>\n      <Country>DE</Country>\n      <Currency>EUR</Currency>\n      <DispatchTimeMax>2</DispatchTimeMax>\n      <ListingDuration>GTC</ListingDuration>\n      <ListingType>FixedPriceItem</ListingType>\n      <PictureDetails>\n         <GalleryType>Gallery</GalleryType>\n         <PictureSource>Vendor</PictureSource>\n         <PictureURL>https://tcgpowertools.nbg1.your-objectstorage.com/images/mtg/#PRODUCT_ID#.jpg</PictureURL>\n      </PictureDetails>\n      <ItemSpecifics>\n         <NameValueList>\n            <Name>\n               <![CDATA[Spiel]]>\n            </Name>\n            <Value>\n               <![CDATA[Magic: The Gathering]]>\n            </Value>\n         </NameValueList>\n         <NameValueList>\n            <Name>\n               <![CDATA[Edition]]>\n            </Name>\n            <Value>\n               <![CDATA[#EXPANSION_NAME#]]>\n            </Value>\n         </NameValueList>\n         <NameValueList>\n            <Name>\n               <![CDATA[Kartenname]]>\n            </Name>\n            <Value>\n               <![CDATA[#CARD_NAME#]]>\n            </Value>\n         </NameValueList>\n         <NameValueList>\n            <Name>\n               <![CDATA[Seltenheit]]>\n            </Name>\n            <Value>\n               <![CDATA[#RARITY#]]>\n            </Value>\n         </NameValueList>\n         <NameValueList>\n            <Name>\n               <![CDATA[Bewertet]]>\n            </Name>\n            <Value>\n               <![CDATA[9.5]]>\n            </Value>\n         </NameValueList>\n      </ItemSpecifics>\n      <PostalCode>14057</PostalCode>\n      <Location>Berlin</Location>\n      <PostCheckoutExperienceEnabled>true</PostCheckoutExperienceEnabled>\n      <Quantity>#QUANTITY#</Quantity>\n      <SellerProfiles>\n         <SellerReturnProfile>\n            <ReturnProfileName>Return</ReturnProfileName>\n            <SellerPaymentProfile>\n               <PaymentProfileName>Payment</PaymentProfileName>\n            </SellerPaymentProfile>\n         </SellerReturnProfile>\n         <SellerShippingProfile>\n            <ShippingProfileName>Shipping</ShippingProfileName>\n         </SellerShippingProfile>\n      </SellerProfiles>\n      <Site>Germany</Site>\n   </Item>\n  </AddFixedPriceItemRequest>";
exports.EndFixedPriceItemRequest = "<EndFixedPriceItemRequest xmlns=\"urn:ebay:apis:eBLBaseComponents\">\n    <SKU>#SKU#</SKU>\n    <EndingReason>NotAvailable</EndingReason>\n</EndFixedPriceItemRequest>";
exports.GetUserRequest = "\n<GetUserRequest xmlns=\"urn:ebay:apis:eBLBaseComponents\"> \n</GetUserRequest>";
//# sourceMappingURL=lib.js.map